<template>
  <div class="section fill">
    <div class="inner">
      <!-- Review -->
      <div class="detail_review">
        <h3 v-if="getCurrentUser" class="sub_tit">
          {{ $t('library.reviewbox.7421') }}
        </h3>

        <!-- Review 작성 START -->
        <form v-if="getCurrentUser" class="review_input_form">
          <div class="review_text_wrap">
            <label for="reviewBox" class="hidden">도서 후기 작성</label>
            <textarea
              id="reviewBox"
              v-model="newReview.review"
              class="review_input_t correct-border"
              name="review"
              :placeholder="$t('library.reviewbox.9283')"
              maxlength="500"
            ></textarea>
          </div>

          <div class="review_bottom_wrap">
            <!-- Review 별점 -->
            <div class="review_score_box">
              <span class="review_score_txt">
                {{ $t('library.reviewbox.rating') }}</span
              >
              <div class="review_score_area">
                <star-rating
                  class="star-rating"
                  :rating="newReview.score"
                  active-color="#FBE116"
                  :star-size="starSize"
                  :increment="increment"
                  :show-rating="showRating"
                  @rating-selected="setRating"
                />
              </div>
            </div>

            <div class="review_btn_wrap">
              <div class="review_write_wrap">
                <button class="box_btn" @click.prevent="registerNewReview">
                  <span class="an_t">등록</span>
                </button>
              </div>
            </div>
          </div>

          <!-- <div class="guide_txt">
            <p>{{ $t('library.reviewbox.7654') }}</p>
          </div> -->
        </form>
        <!-- Review 작성 END -->

        <div class="review_content_wrap">
          <div class="review_top">
            <!-- Review Order -->
            <ul class="board_sort">
              <li>
                <a
                  tabindex="0"
                  :class="{ active: sortBy === 'WD' }"
                  @click="setSortBy('WD')"
                  @keypress.enter="setSortBy('WD')"
                  ><span>{{ $t('library.reviewbox.7374') }}</span></a
                >
              </li>
              <li>
                <a
                  tabindex="0"
                  :class="{ active: sortBy === 'ST' }"
                  @click="setSortBy('ST')"
                  @keypress.enter="setSortBy('ST')"
                  ><span>{{ $t('library.reviewbox.991') }}</span></a
                >
              </li>
              <li>
                <a
                  tabindex="0"
                  :class="{ active: sortBy === 'EG' }"
                  @click="setSortBy('EG')"
                  @keypress.enter="setSortBy('EG')"
                  ><span>{{ $t('library.reviewbox.good') }}</span></a
                >
              </li>
              <li>
                <a
                  tabindex="0"
                  :class="{ active: sortBy === 'EB' }"
                  @click="setSortBy('EB')"
                  @keypress.enter="setSortBy('EB')"
                  ><span>{{ $t('library.reviewbox.bad') }}</span></a
                >
              </li>
            </ul>

            <div class="text_label">
              <ul class="moblie_sort review_tab">
                <li>
                  <a
                    tabindex="0"
                    :class="{ active: !category }"
                    @keypress.enter="setCategory(null)"
                    @click="setCategory(null)"
                    ><span
                      >{{ $t('library.reviewbox.7718')
                      }}<em>{{ getStoreBookReviewAllTotalCount }}</em></span
                    ></a
                  >
                </li>
                <li>
                  <a
                    tabindex="0"
                    :class="{ active: category === 'PG' }"
                    @keypress.enter="setCategory('PG')"
                    @click="setCategory('PG')"
                    ><span
                      >{{ $t('library.reviewbox.6340')
                      }}<em>{{
                        getStoreBookReviewPurchasedTotalCount
                      }}</em></span
                    ></a
                  >
                </li>
              </ul>
            </div>
          </div>

          <!-- SHOW IF NO REVIEWS EXIST -->
          <ul
            v-if="
              !isStoreBookReviewLoading &&
              ((!category && !getStoreBookReviewAllTotalCount) ||
                (category && !getStoreBookReviewPurchasedTotalCount))
            "
            class="review_content_list"
          >
            <li>
              <p class="not_comment">{{ $t('library.reviewbox.7122') }}</p>
            </li>
          </ul>

          <!-- REVIEWS -->
          <ReviewItem
            v-for="(review, idx) in getStoreBookReviews"
            :key="idx"
            :review="review"
            @reload="loadReviews"
          />

          <Pagination
            :current-page="currentPage"
            :total-count="totalCount"
            :item-per-page="reviewsPerPage"
            @paginate="paginate"
          />
        </div>
      </div>
      <!-- Review -->
    </div>

    <!-- ERROR MODAL -->
    <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
      <Modal v-if="showErrorModal" @close="toggleErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleErrorModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner">
              <p>
                {{ errorMessage }}
              </p>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import ReviewItem from './ReviewItem.vue'
import StarRating from 'vue-star-rating'

import { mapGetters } from 'vuex'
import {
  AUTH_REFRESH,
  AUTH_LOGOUT,
  ACCOUNT_REVIEW_CREATE,
  STORE_BOOK_REVIEW_GET_LIST,
  ACCOUNT_REVIEW_SUCCESS
} from '@/store/types'

export default {
  name: 'ReviewBox',

  components: {
    StarRating,
    ReviewItem
  },
  data() {
    return {
      newReview: {},
      currentPage: 1,
      reviewsPerPage: 10,
      sortBy: 'WD',
      category: null,
      // For star-rating package
      starSize: 30,
      increment: 0.5,
      showRating: false,
      showErrorModal: false,
      errorMessage: ''
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentUser',
      'getStoreBookReviews',
      'getStoreBookReviewAllTotalCount',
      'getStoreBookReviewPurchasedTotalCount',
      'getStoreCurrentBook',
      'isStoreBookReviewLoading'
    ]),
    totalCount() {
      if (this.category) {
        return this.getStoreBookReviewPurchasedTotalCount
      }
      return this.getStoreBookReviewAllTotalCount
    }
  },
  async mounted() {
    const token = localStorage.getItem('token')
    if (!this.getCurrentUser && token) {
      try {
        await this.$store.dispatch(AUTH_REFRESH)
      } catch (err) {
        await this.$store.dispatch(AUTH_LOGOUT)
      }
    }

    await this.loadReviews()
  },
  methods: {
    toggleErrorModal(errorMessage) {
      this.showErrorModal = !this.showErrorModal

      if (errorMessage) {
        this.errorMessage = errorMessage
      }
    },
    async loadReviews() {
      const { currentPage, reviewsPerPage, sortBy, category } = this
      const id = this.$route.params.id
      await this.$store
        .dispatch(STORE_BOOK_REVIEW_GET_LIST, {
          id,
          page: currentPage,
          pageRow: reviewsPerPage,
          search: sortBy,
          category
        })
        .then((res) => {
          this.$store.commit(ACCOUNT_REVIEW_SUCCESS, {
            reviews: res.data.result.bookReviewList
            // meta: {
            //   allTotalCount: res.data.result.listAllCnt,
            //   purchasedTotalCount: res.data.result.listPurchaseCnt
            // }
          })
        })
    },
    async registerNewReview() {
      const review = {
        ...this.newReview,
        bookCd: this.getStoreCurrentBook.id
      }
      try {
        await this.$store.dispatch(ACCOUNT_REVIEW_CREATE, review)
        this.loadReviews()
        this.newReview = {
          score: null
        }
      } catch (err) {
        if (err.response && err.response.data.errorState) {
          this.toggleErrorModal(
            `[${err.response.data.errorState.code}] ${err.response.data.errorState.message}`
          )
        }
      }
    },
    setRating(rating) {
      this.newReview.score = rating
    },
    setCategory(category) {
      this.category = category
      this.currentPage = 1
      this.loadReviews()
    },
    setSortBy(sortBy) {
      this.sortBy = sortBy
      this.currentPage = 1
      this.loadReviews()
    },
    paginate(page) {
      this.currentPage = page
      this.loadReviews()
    }
  }
}
</script>

<style lang="scss" scoped>
.correct-border {
  padding: 10px;
  height: 100%;
  border-radius: 15px;
}

.review_text_wrap {
  padding: 0px;
}
</style>
